package fyi.moko.hotpl.domain.model

/**
 * Platform-independent latitude/longitude pair.
 * Replaces `com.google.android.gms.maps.model.LatLng` throughout shared code.
 */
data class GeoPoint(val latitude: Double, val longitude: Double)
